import React from 'react';
import { PapiComment } from '@wix/da-papi-types';
import { NullableDropdownItem } from '@wix/da-ds/pkg/Dropdown/types';
import { EditingState } from '../redux/types';

export interface CommentContextValues {
  comment: PapiComment;
  isEditing: boolean;
  isReplying: boolean;

  /** Whether the user has unhidden a spam or hidden comment. */
  isPeeking: boolean;
  canShowActionMenu: boolean;
  isCommentVisible: boolean;
  isReduxReady: boolean;
  setEditingState: (value: EditingState) => void;

  /** Sets whether the user is peaking at a hidden comment or not */
  setPeeking: (value: boolean) => void;
  setCanShowActionMenu: (value: boolean) => void;

  /** An array of NullableDropdownItems for the comment's action menu the viewer
   *  can perform on the comment that are in addition to the standard actions in
   *  ActionsMenu (like feature, hide, etc.) */
  extraActions?: NullableDropdownItem[];
}

export const CommentContext = React.createContext<CommentContextValues>({
  comment: {} as PapiComment,
  isEditing: false,
  isReplying: false,
  isPeeking: false,
  isReduxReady: false,
  canShowActionMenu: false,
  isCommentVisible: true,
  setEditingState: () => null,
  setCanShowActionMenu: () => null,
  setPeeking: () => null,
});
CommentContext.displayName = 'CommentContext';
